export default __webpack_public_path__ + "static/media/class_positive.c26d77e7.svg";